class Business {
  constructor(settings) {
    this.settings = {
      formSelector: '#business-form',
      ...settings,
    };
  }

  init() {
    this.startEvents();
  }

  startEvents() {
    const form = document.querySelector(this.settings.formSelector);

    if (form) {
      form.addEventListener('submit', this.triggerSubmissionForm.bind(this));
    }
  }

  triggerSubmissionForm(event) {
    event.preventDefault();
    const form = event.target;

    ga('send', 'event', {
      eventCategory: 'Business',
      eventAction: 'Submit form',
      eventLabel: 'Submit',
    });

    form.submit();
  }

  getClientId() {
    let clientId = '';

    ga((tracker) => {
      clientId = tracker.get('clientId');
    });

    return clientId;
  }
}

const business = new Business();
business.init();
